<script lang="ts">
import { get } from 'svelte/store'
import { fly } from 'svelte/transition'

import { testIds } from '@/constants'
import { isDisconnected } from '@/modules/app/connectionStatus'
import { DrawerId, openDrawer } from '@/modules/drawers'
import { BOT_REPLY_DELAY, isReplyProcessing } from '@/modules/messages'
import { t } from '@/modules/translations'

import Button from '../core/Button.svelte'

const handleClick = () => {
	if (get(isReplyProcessing)) return
	openDrawer(DrawerId.TicketForm)
}
</script>

<div
	in:fly|global={{ delay: BOT_REPLY_DELAY, duration: 300, x: -20 }}
	class="flex flex-wrap justify-end"
	data-testid={testIds.ticketFormSubmitButton}
>
	<Button variant="outline" disabled={$isDisconnected} style={'height: fit-content'} onClick={handleClick}>
		<p class="py-2 break-all">{$t('ticketForm.submit.button')}</p>
	</Button>
</div>
